export const getYear = state => state.reportCustomerSpeditions.getIn(['list', 'year'])
export const getData = state => state.reportCustomerSpeditions.getIn(['list', 'data'])
export const getFetching = state => state.reportCustomerSpeditions.getIn(['list', 'fetching'])
export const getError = state => state.reportCustomerSpeditions.getIn(['list', 'error'])

export const getDetailsData = state => state.reportCustomerSpeditions.getIn(['details', 'data'])
export const getDetailsFetching = state => state.reportCustomerSpeditions.getIn(['details', 'fetching'])
export const getDetailsError = state => state.reportCustomerSpeditions.getIn(['details', 'error'])
